import * as Actions from 'reducks/nav/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const NavReducer = (state = initialState.nav, action: any) => {
  switch (action.type) {
    case Actions.CLOSE_SUB_HEADER:
      return {
        ...state,
        sub_header: {
          open: action.payload,
        },
      }
    case Actions.TOGGLE_SUB_HEADER:
      return {
        ...state,
        sub_header: {
          open: action.payload,
        },
      }
    default:
      return state
  }
}
